import { Dictionary } from "./dictionary";

export enum ERoles {
    admin = "ADMIN",
    director = "DIRECTOR",
    lawyer = "LAWYER",
    credit_manager = "CREDIT_MANAGER",
    client = "CLIENT",
    auditor = "AUDITOR",
}
  
export type Roles = Omit<Dictionary, "description">;